import { isSupportedLanguage, SupportedLanguage } from '../data/languages';

export type HeaderFooterParams = {
  sticky?: boolean;
  language?: string;
  header?: boolean;
  footer?: boolean;
};

export class Config {
  constructor(private readonly data: HeaderFooterParams) {}

  public isSticky = () => this.data.sticky ?? true;

  public isHeaderUsed = () => this.data.header ?? true;

  public isFooterUsed = () => this.data.footer ?? true;

  public getContentLanguage = (): SupportedLanguage => (isSupportedLanguage(this.data.language) ? this.data.language : 'en');

  public getPageLanguage = () => this.data.language;
}
